(() => {
  const rules = window.JS360_PATCH_RULES;
  if (!Array.isArray(rules)) return;

  // JerseyZone reused numeric codes over time. Current European codes such as
  // Barcelona 045 must never trigger old Brazilian/South-American rules.
  // For CONMEBOL/Brazil competition rules, only retain the current 1xx club
  // codes. Team-name rules and the explicit storefront safety allow-list remain
  // available as independent safeguards.
  const southAmericanRule = (handle) => {
    const h = String(handle || '').toLowerCase();
    return h.includes('libertadores') ||
      h.includes('copa-do-brasil') ||
      h.includes('brasileirao') ||
      h.includes('sudamericana') ||
      h === 'patch-130-anos';
  };

  rules.forEach((rule) => {
    if (!southAmericanRule(rule.handle)) return;
    rule.codes = (rule.codes || []).filter((raw) => {
      const value = String(raw || '').replace(/^code-/i, '').trim();
      const number = Number(value);
      return Number.isInteger(number) && number >= 100 && number <= 199;
    });
  });

  // Explicit current JerseyZone club-code corrections.
  const exact = {
    'patch-campeao-da-libertadores-gremio': ['108'],
    'patch-campeao-da-libertadores-vasco-da-gama': ['105'],
    'patch-campeao-da-libertadores-flamengo': ['104'],
    'patch-campeao-da-libertadores-botafogo': ['106'],
    'patch-campeao-da-libertadores-fluminense': ['107'],
    'patch-campeao-da-libertadores-1-corinthians': ['102'],
    'patch-campeao-da-libertadores-sao-paulo': ['103'],
    'patch-campeao-da-libertadores-santos': ['113'],
    'patch-campeao-da-libertadores-internacional': ['109'],
    'patch-campeao-da-libertadores-atlerico-mineiro': ['110'],
    'patch-campeao-da-libertadores-palmeiras': ['101'],
    'patch-campeao-da-libertadores-cruzeiro': ['111']
  };
  rules.forEach((rule) => {
    if (exact[rule.handle]) rule.codes = exact[rule.handle].slice();
  });

  window.JS360_PATCH_RULES_NORMALIZED = true;
})();
